<template>
    <div>
        <div class="topImgCtn">
            <img class="titleImg" src="../assets/RegisterNew/隐私政策title.png" height="260" width="1280"/>
        </div>
        <div style="margin-left:auto;margin-right:auto;width: 1120px;height: auto;padding-top:67px;padding-bottom: 67px;">
            <img src="../assets/RegisterNew/隐私政策content.png" height="3248" width="1120"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PrivacyPolicy"
    }
</script>

<style scoped>
    .contentImg{
        position:relative;
        left:50%;
        margin-left: -560px;
    }
    .titleImg{
        position:absolute;
        bottom:0px;
        left:50%;
        margin-left: -640px;
    }
    .topImgCtn{
        position:relative;
        background-image:url('../assets/RegisterNew/隐私政策.jpg') ;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position:relative;
        width: 100vw;
        height:40vw;
    }
</style>